import { MissionsUrlProvider } from '@/features/missions/context/MissionsUrlProvider'
import { NectarTaskPage as NectarTask } from '@/features/nectar/components/NectarTaskPage'
import { Page } from '@/ui-kit'
import { useParams } from 'react-router-dom'

const NectarTaskPage = () => {
  const { projectId } = useParams<{ projectId: string }>()

  return (
    <MissionsUrlProvider isWebview={false}>
      <Page>
        <NectarTask projectId={projectId ?? ''} />
      </Page>
    </MissionsUrlProvider>
  )
}

export default NectarTaskPage
